import React from "react";

interface IProps {
    date?: Date;
    includeDay?: boolean;
    includeYear?: boolean;
}


const FormatDate: React.FC<IProps> = ({ date, includeDay = true, includeYear = false }) => {

    if (!date) {
        return <span />;
    }

    if (typeof(date) !== "object") {
        date = new Date(date);
    }

    const days = ["Sun", "Mon", "Tues", "Weds", "Thurs", "Fri", "Sat"];
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"];
    
    const day = date.getDate();
    let suffix: string;

    if ([1, 21, 31].includes(day)) {
        suffix = "st";
    } else if ([2, 22].includes(day)) {
        suffix = "nd";
    } else if ([3, 23].includes(day)) {
        suffix = "rd";
    } else {
        suffix = "th";
    }

    let finalDate = "";

    if (includeDay) {
        finalDate += `${days[date.getDay()]} `;
    }

    finalDate += `${date.getDate()}${suffix} ${months[date.getMonth()]}`;

    if (includeYear) {
        finalDate += ` ${date.getFullYear()}`;
    }

    return (
        <span>{finalDate}</span>
    )
}

export default FormatDate;